import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export type InvoiceStatus = 'paid' | 'pending' | 'user-ran'

export interface IInvoices {
    id: string
    user_id: string
    user_nickname: string
    key_id: string
    bot_id: string
    leader_key_id: string
    leader_user_id: string
    leader_name: string
    user_identifier: string
    amount: number
    paid: number
    pnl: number
    status: InvoiceStatus
    from_time: string
    to_time: string
    created_at: string
    updated_at: string
    last_sent_at: string
    due_at: string
    deposit: number
    withdraw: number
    start_balance: number
    end_balance: number
    effective_end_balance: number
    hwm: number
    next_hwm: number
    cut_percent: number
    paid_by_id: string
    paid_by_name: string
    paid_at: string
    period_profit?: number
    discount_percent?: number
}

export const getInvoices = async (pageSize: number, currentPage: number = 1): Promise<ApiRes<IInvoices[]>> => {
    return await apiGet(API_URL, `admin/invoices?current_page=${currentPage}&page_size=${pageSize}`)
}
